(function () {
  const AUTOPLAY_MS = 5000;

  const setSlide = (root, index) => {
    const viewport = root.querySelector('[data-slider-viewport]');
    const slides = root.querySelectorAll('[data-slider-slide]');
    const dots = root.querySelectorAll('[data-slider-dot]');
    if (!viewport || !slides.length) return;

    const max = slides.length;
    const next = ((index % max) + max) % max;

    viewport.style.transform = 'translate3d(-' + next * 100 + '%, 0, 0)';
    viewport.dataset.currentSlide = String(next);

    dots.forEach((dot, i) => {
      const active = i === next;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.dataset.currentIndex = String(next);
  };

  const initSlider = (root) => {
    if (root.dataset.pdpPromoReady === 'true') return;
    root.dataset.pdpPromoReady = 'true';

    const slides = root.querySelectorAll('[data-slider-slide]');
    if (slides.length <= 1) return;

    let timer = null;
    const delay = parseInt(root.dataset.autoplay || AUTOPLAY_MS, 10) || AUTOPLAY_MS;

    const goTo = (index) => {
      setSlide(root, index);
    };

    const next = () => {
      const current = parseInt(root.dataset.currentIndex || '0', 10) || 0;
      goTo(current + 1);
    };

    const restart = () => {
      if (timer) window.clearInterval(timer);
      timer = window.setInterval(next, delay);
    };

    root.querySelectorAll('[data-slider-dot]').forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.sliderDot || '0', 10) || 0;
        goTo(index);
        restart();
      });
    });

    goTo(0);
    restart();

    root.addEventListener('mouseenter', () => {
      if (timer) window.clearInterval(timer);
    });
    root.addEventListener('mouseleave', restart);
  };

  const boot = () => {
    document.querySelectorAll('[data-pdp-promo-slider]').forEach(initSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
